export function getApiBase() {
  return (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
}

const apiBase = getApiBase();

/**
 * Multipart upload helper — does not set Content-Type so the browser sets the boundary.
 */
export async function apiUpload(path, formData, authToken = null) {
  const headers = { Accept: 'application/json' };
  if (authToken) {
    headers.Authorization = `Bearer ${authToken}`;
  }
  return fetch(`${apiBase}${path}`, {
    method: 'POST',
    headers,
    body: formData,
  });
}

export async function apiPost(path, body, authToken = null) {
  const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
  if (authToken) {
    headers.Authorization = `Bearer ${authToken}`;
  }
  const response = await fetch(`${apiBase}${path}`, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });
  return response;
}

export async function apiGet(path, authToken = null) {
  const headers = { Accept: 'application/json' };
  if (authToken) {
    headers.Authorization = `Bearer ${authToken}`;
  }
  return fetch(`${apiBase}${path}`, {
    method: 'GET',
    headers,
  });
}

export async function apiPatch(path, body, authToken = null) {
  const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
  if (authToken) {
    headers.Authorization = `Bearer ${authToken}`;
  }
  return fetch(`${apiBase}${path}`, {
    method: 'PATCH',
    headers,
    body: JSON.stringify(body),
  });
}

export async function apiPut(path, body, authToken = null) {
  const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
  if (authToken) {
    headers.Authorization = `Bearer ${authToken}`;
  }
  return fetch(`${apiBase}${path}`, {
    method: 'PUT',
    headers,
    body: JSON.stringify(body),
  });
}
